import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import httpApiKasir from "../axios/http-api-kasir";
import { Tindakan } from "@/types/billing";

async function postPelayanan(data) {
  const response = await http
    .postData("/billing/transaksi", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function postBatalPeriksa(register) {
  const response = await http
    .postData(`/billing/register/${register}/batal-periksa`, null)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getPelayananbyUnit(unit) {
  const response = await http
    .getData(`/billing/unit/${unit}/pelayanan`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getTindakanbyReg(
  reg
): Promise<{
  status: 0 | 1;
  data: null | Tindakan[];
  message?: string;
}> {
  const response = await http.getData(`/billing/register/${reg}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function getTindakanbyRequest(reg, tgl, jam, unit) {
  const response = await http
    .getData(`/billing/register/${reg}/tanggal/${tgl}/jam/${jam}/unit/${unit}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function lockRegister(reg, user, unit, aplikasi) {
  const response = await http
    .postData(
      `/billing/lock-wreg/app/${aplikasi}/register/${reg}/user/${user}/unit/${unit}`,
      null
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function unlockRegister(reg, user, aplikasi) {
  const response = await http
    .postData(
      `/billing/unlock-wreg/app/${aplikasi}/register/${reg}/user/${user}`,
      null
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function postDiagnosa(data) {
  const response = await http.postData("/diagnosis-icd", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function getDiagnosisbyReg(reg, eps = "rj") {
  const response = await http
    .getDataParam(`/register/${reg}/diagnosis-icd`, {
      params: {
        episode: eps
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function postProcedure(data) {
  const response = await http.postData("/procedure-icd", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function getProcedurebyReg(reg, eps = "rj") {
  const response = await http
    .getDataParam(`/register/${reg}/procedure-icd`, {
      params: {
        episode: eps
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getKondisiDasar(unit) {
  const response = await http
    .getData(`/billing/unit/${unit}/kondisi-dasar-isian`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function postAskep(data) {
  const response = await http.postData("/billing/askep", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function getAskep(data) {
  const response = await http
    .getDataParam(`/billing/askep`, {
      params: {
        tanggal: data["tanggal"],
        unit_id: data["unit_id"],
        rm: data["rm"],
        register_id: data["register_id"],
        shift: data["shift"]
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function deleteAskep(data) {
  const response = await http
    .deleteDataParam(`/billing/askep`, {
      params: {
        tanggal: data["tanggal"],
        unit_id: data["unit_id"],
        rm: data["rm"],
        register_id: data["register_id"],
        register_tgl: data["register_tgl"],
        shift: data["shift"],
        auth: data["auth"]
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getStatusRegister(reg, unit) {
  const response = await http
    .getData(`/billing/register/${reg}/unit/${unit}/cek-status`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getStatusPlafonPerUnit(unit) {
  const response = await http
    .getData(`/billing/unit/${unit}/status-plafon`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getStatusBillingKasir(reg) {
  if (!process.env.VUE_APP_API_KASIR) {
    return { status: 0, data: null };
  }
  const response = await httpApiKasir
    .getDataParam(`/cekstatusbilling`, {
      reg: reg
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function setStatusFinalKasir(
  reg: number,
  status: 1 | 0,
  usrName: string
) {
  const response = await httpApiKasir
    .postData(`/finalkasir`, {
      reg: reg,
      finalkasir: status,
      user: usrName
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

export default {
  postPelayanan,
  postBatalPeriksa,
  getPelayananbyUnit,
  lockRegister,
  unlockRegister,
  getTindakanbyReg,
  getTindakanbyRequest,
  postDiagnosa,
  getDiagnosisbyReg,
  postProcedure,
  getProcedurebyReg,
  getKondisiDasar,
  postAskep,
  getAskep,
  deleteAskep,
  getStatusRegister,
  getStatusPlafonPerUnit,
  getStatusBillingKasir,
  setStatusFinalKasir
};
